<template>
  <div class="overview">
    <div class="top_overview" v-if="isHas">
      <div class="overview-box-item fl">
        <div class="title">客户数据</div>
        <div class="flex flex-center">
          <div class="items">
            <i></i>
            <span class="totel">客户总数</span>
            <div class="num">{{ sumCnt }}<span>位</span></div>
          </div>
          <div class="items">
            <i></i>
            <span class="totel">今日新增</span>
            <div class="num">{{ newContactCnt }}<span>位</span></div>
          </div>
          <div class="items">
            <i></i>
            <span class="totel">今日流失</span>
            <div class="num">{{ negativeFeedbackCnt }}<span>位</span></div>
          </div>
        </div>
      </div>
      <div class="overview-box-item fr" v-if="noShow">
        <div class="title">群数据</div>
        <div class="flex flex-center">
          <div class="items">
            <i></i>
            <span class="totel">群总数</span>
            <div class="num">8768<span>位</span></div>
          </div>
          <div class="items">
            <i></i>
            <span class="totel">今日新增群聊</span>
            <div class="num">8768<span>位</span></div>
          </div>
          <div class="items">
            <i></i>
            <span class="totel">今日新增群城群</span>
            <div class="num">8768<span>位</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="overview-box top_overview_no" v-else>
      <img
        src="https://imgcdn.hemiao100.com/ThemePictures/wc1.png"
        alt=""
        class="fl"
      />
      <div class="no_rt fl">
        <p>企微助手</p>
        <div>企业微信私域运营与内容营销解决方案</div>
        <el-button type="primary" @click="goRegister">立即开通</el-button>
      </div>
    </div>

    <div class="overview-box" v-if="isHas">
      <div class="top">
        <div class="fr">
          <el-date-picker
            clearable
            v-model="valueTime"
            type="daterange"
            align="right"
            start-placeholder="请选择开始时间"
            end-placeholder="请选择结束时间"
            value-format="yyyy-MM-dd"
            size="small"
            class="mr10"
            @change="createTimeArryChange"
          ></el-date-picker>
        </div>
        <div class="fl">
          <div
            v-for="(v, i) in h"
            :key="i"
            @click="detail(i, v)"
            class="tab-btn text-center pointer"
          >
            <div class="p10" :class="{ active: isActive == i }">
              <div style="font-size: 14px">
                {{ v.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div id="mainline" style="height: 400px"></div>
      </div>
    </div>

    <div class="overview-box" v-else>
      <img
        class="overview-box-bg"
        src="https://imgcdn.hemiao100.com/ThemePictures/wc2.png"
        alt=""
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      width="35%"
      :visible.sync="dialogVisible"
    >
      <div slot="title" style="height:18px"></div>
      <div class="wrapper_body">
        <img
          src="https://imgcdn.hemiao100.com/ThemePictures/wc3.png"
          alt=""
          class="top_img"
        />
        <p class="tex">接入企业微信-体验企业服务新方式</p>
        <div class="next_btn pointer" @click="nextBtn('1')">
          <i class="hmicon icon-search"></i>
          <span>去企业微信授权</span>
        </div>
        <div class="next_btn pointer" @click="nextBtn('2')">
          <img
            class="icon_wc4"
            src="https://imgcdn.hemiao100.com/ThemePictures/wc4.png"
            alt=""
          />
          <span>注册企业微信</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import echarts from "echarts";
import { ToFixed } from "@/utils/utils";
// var echarts = require("echarts/lib/echarts");
// require("echarts/lib/chart/bar");
// require("echarts/lib/component/title");
// require("echarts/lib/chart/line");
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      queryStartTime: "",
      queryEndTime: "",
      valueTime: [],
      storeCode: "",
      URL: "",
      sumCnt: 0,
      newContactCnt: 0,
      negativeFeedbackCnt: 0,
      noShow: false,
      dialogVisible: false,
      isHas: false,
      isActive: 0,
      daysTip: "",
      tipGoods: [],
      configModel: {},
      active: 0,
      lists: [],
      sumCnts: 0,
      newContactCnts: 0,
      negativeFeedbackCnts: 0,
      h: [
        {
          name: "客户总数",
          val: 0,
          background: "#B839F2",
          rgba:
            "linear-gradient(180deg, rgba(184, 57, 242, 0.3) 0%, rgba(255, 255, 255, 0) 100%)",
          queryStatus: "notice"
        },
        {
          name: "新增客户数",
          val: 0,
          background: "#F58D34",
          rgba:
            "linear-gradient(180deg, rgba(245, 141, 52, 0.3) 0%, rgba(255, 255, 255, 0) 100%)",
          queryStatus: "visit"
        },
        {
          name: "流失客户数",
          val: 0,
          background: "#16CEB9",
          rgba:
            "linear-gradient(180deg, rgba(22, 206, 185, 0.3) 0%, rgba(255, 255, 255, 0) 100%)",
          queryStatus: "pay"
        }
      ],
      searchCondition: {
        createTimeArry: []
      },
      optionLineData: [],
      optionLine: {
        tooltip: {
          trigger: "axis"
        },
        legend: {},
        xAxis: {
          type: "category",
          data: []
        },
        yAxis: {
          type: "value",
          axisLabel: {},
          minInterval: 1
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#2E7EE9"
                }
              }
            },
            areaStyle: {
              color: "#2E7EE9"
            }
          }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    let curDate = new Date();
    let curDate0 = new Date(curDate.getTime());
    let queryStartTime0 = this.formatDateTime(curDate0);
    let preDate7 = new Date(curDate.getTime() - 7 * 24 * 60 * 60 * 1000); //前7天
    let queryStartTime7 = this.formatDateTime(preDate7);
    this.queryStartTime = queryStartTime7;
    this.queryEndTime = queryStartTime0;
    this.valueTime = [this.queryStartTime, this.queryEndTime];
  },
  mounted() {
    this.init();
  },
  methods: {
    goRegister() {
      this.$router.push({
        name: "WechatInstall"
      });
      // this.getUrl();
      // this.dialogVisible = true;
    },
    async init() {
      let res = await this.$store.dispatch("wechartHead");
      this.negativeFeedbackCnt = res.result.negativeFeedbackCnt;
      this.newContactCnt = res.result.newContactCnt;
      this.sumCnt = res.result.sumCnt;
      this.storeCode = res.result.storeCode;
      console.log("storeCode----result", this.storeCode);
      if (res.errMsg == "未开通企业微信通道") {
        // this.$message({
        //   message: "未开通企业微信通道！",
        //   type: "warning"
        // });
      } else {
        this.wechartStatistics();
        this.isHas = true;
      }
    },
    formatDateTime(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d;
    },
    // 客户数据
    async wechartStatistics() {
      let res = await this.$store.dispatch("wechartStatistic", {
        beginDate: this.valueTime[0],
        endDate: this.valueTime[1]
      });
      if (res.result) {
        this.lists = res.result;
        this.optionLineData = res.result;
        let time = [];
        let data1 = [];
        let data2 = [];
        let data3 = [];
        res.result.forEach(v => {
          this.sumCnts += v.sumCnt;
          this.newContactCnts += v.newContactCnt;
          this.negativeFeedbackCnts += v.negativeFeedbackCnt;
          time.push(v.date);
          data1.push(v.sumCnt || 0);
          data2.push(v.newContactCnt || 0);
          data3.push(v.negativeFeedbackCnt || 0);
        });
        this.optionLine.xAxis.data = time;
        if (this.isActive == 0) {
          this.optionLine.series[0].data = data1;
        }
        if (this.isActive == 1) {
          this.optionLine.series[0].data = data2;
        }
        if (this.isActive == 2) {
          this.optionLine.series[0].data = data3;
        }
        this.optionLine.legend.data = [this.h[this.isActive].name];
        this.optionLine.series[0].name = this.h[this.isActive].name;

        console.log("this.optionLine: ", this.optionLine);
        this.optionLine.xAxis.data = time;
        this.$nextTick(() => {
          var myChart = echarts.init(document.getElementById("mainline"));
          myChart.setOption(this.optionLine);
        });
      }
    },
    createTimeArryChange(e) {
      this.valueTime[0] = e[0];
      this.valueTime[1] = e[1];
      this.wechartStatistics();
    },
    // 图表tab切换
    detail(i, v) {
      console.log(i, v);
      this.isActive = i;
      this.wechartStatistics();
    },
    // 企业微信 获取第三方应用凭证
    async getUrl() {
      let params = {
        storeCode: this.storeCode
      };
      const formData = new FormData();
      Object.keys(params).forEach(key => {
        formData.append(key, params[key]);
      });
      let res = await this.$store.dispatch("wechartGetSuiteToken", formData);
      this.URL = res.result;
      console.log("this.URL: ", this.URL);
    },
    nextBtn(val) {
      // 授权
      if (val == "1") {
        window.open(this.URL, "_blank");
      }
      // 注册
      if (val == "2") {
        window.open(
          "https://work.weixin.qq.com/nl/sem/registe?s=c&from=1011029125&bd_vid=10378365559517249278",
          "_blank"
        );
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.overview {
  padding-top: 10px;
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .top_overview {
    height: 172px;
    background: #f4f4f4;
  }
  .overview-box {
    padding: 20px;
    background: #fff;
    .top {
      width: 100%;
      height: 100px;
      .tabs {
      }
    }
  }
  .top_overview {
    height: 172px;
    background: #f4f4f4;
    margin-bottom: 10px;
    .overview-box-item {
      width: 100%;
      background: #fff;
      height: 172px;
      padding: 20px;
      box-sizing: border-box;
      justify-content: center;
      align-items: center;
      .title {
        width: 100%;
        line-height: 30px;
        margin-bottom: 20px;
        font-weight: bold;
        &::before {
          display: inline-block;
          margin-right: 5px;
          content: "";
          width: 4px;
          height: 14px;
          background: #e50065;
          border-top-left-radius: 30px;
          border-bottom-right-radius: 30px;
        }
      }
      .items {
        flex: 1;
        text-align: center;
        margin: 0 auto;
        \ i {
          width: 16px;
          height: 16px;
        }
        .totel {
          height: 22px;
          font-size: 16px;
          color: #222222;
          line-height: 22px;
        }
        .num {
          height: 40px;
          font-size: 28px;
          font-weight: 500;
          color: #222222;
          line-height: 40px;
          span {
            font-size: 12px;
            font-weight: 400;
            color: #222222;
          }
        }
      }
    }
  }
  .top_overview_no {
    width: 100%;
    height: 190px;
    background: #fff;
    > img {
      width: 180px;
      height: 180px;
      //   background: red;
    }
    .no_rt {
      margin-left: 20px;
      > p {
        font-size: 20px;
        font-weight: 500;
        color: #222222;
        line-height: 45px;
      }
      > div {
        font-size: 14px;
        color: #222222;
        line-height: 20px;
        margin-bottom: 48px;
      }
    }
  }
  .overview-box-bg {
    height: 568px;
    width: 100%;
  }
}
.tab-btn {
  float: left;
  text-align: center;
  line-height: 14px;
  height: 36px;
  border: 1px solid #dddddd;
  box-sizing: border-box;
}
.active {
  background: #e50065;
  color: #fff;
}
// 弹框样式
.wrapper_body {
  .top_img {
    width: 326px;
    height: 36px;
    // background: red;
    margin: 0 20px;
    box-sizing: border-box;
    margin-left: 50%;
    transform: translate(-50%);
  }
  .tex {
    width: 100%;
    text-align: center;
    line-height: 36px;
    font-size: 18px;
    color: #999999;
    margin-bottom: 20px;
  }
  .next_btn {
    width: 320px;
    margin: 0 auto;
    text-align: center;
    height: 48px;
    line-height: 48px;
    border-radius: 4px;
    border: 1px solid #dddddd;
    box-sizing: border-box;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-items: center;
    padding-left: 90px;
    .icon-search {
      font-size: 20px;
    }
    span {
      font-size: 18px;
      padding-left: 10px;
      line-height: 20px;
    }
    .icon_wc4 {
      width: 22px;
      height: 18px;
    }
  }
  .next_btn:hover {
    background: #e50065;
    color: #ffffff;
  }
}
</style>
